import { render, staticRenderFns } from "./cards_list_item.vue?vue&type=template&id=146d480c&"
import script from "./cards_list_item.vue?vue&type=script&lang=js&"
export * from "./cards_list_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports